import React, { useContext } from 'react';
import DisabledOrPrivateInfo from '../../../../lego/DisabledOrPrivateInfo';
import { CommentEditorContext } from '../../../../../CommentEditor/context';

export interface Props {}

const CantPostView: React.FC<Props> = () => {
  const { commentableItemId, commentableType } =
    useContext(CommentEditorContext);
  return (
    <DisabledOrPrivateInfo
      commentableItemId={commentableItemId}
      commentableType={commentableType}
    />
  );
};
CantPostView.displayName = 'CantPostView';

export default CantPostView;
